(function () {
  function initStickyMenuBar() {
    var menuBar = document.querySelector('.wbmenuup');
    if (!menuBar) return;

    var placeholder = document.createElement('div');
    placeholder.className = 'wbmenuup-placeholder';
    placeholder.style.width = '100%';
    menuBar.parentNode.insertBefore(placeholder, menuBar);

    var isSticky = false;

    function getStickyOffset() {
      var stickySection = document.querySelector('.shopify-section-header-sticky');
      if (!stickySection) return 0;
      var headerEl = stickySection.querySelector('header.header');
      return headerEl ? headerEl.offsetHeight : 0;
    }

    function update() {
      var offset = getStickyOffset();
      if (!isSticky) {
        if (menuBar.getBoundingClientRect().top <= offset) {
          placeholder.style.height = menuBar.offsetHeight + 'px';
          placeholder.classList.add('is-active');
          menuBar.style.top = offset + 'px';
          menuBar.classList.add('wbmenuup--sticky');
          isSticky = true;
        }
      } else {
        if (placeholder.getBoundingClientRect().top > offset) {
          menuBar.classList.remove('wbmenuup--sticky');
          menuBar.style.top = '';
          placeholder.classList.remove('is-active');
          isSticky = false;
        }
      }
    }

    function onResize() {
      if (isSticky) menuBar.style.top = getStickyOffset() + 'px';
      update();
    }

    window.addEventListener('scroll', update, { passive: true });
    window.addEventListener('resize', onResize, { passive: true });
    update();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initStickyMenuBar);
  } else {
    initStickyMenuBar();
  }
})();

(function () {
  var mq = window.matchMedia('(max-width: 991px)');
  var panelMap = new Map(); /* li element → portaled panel element */

  /* ── Portal: move panels out of the scroll container ─────────────────── */
  function portalPanels() {
    var menuBar = document.querySelector('.wbmenuup');
    if (!menuBar || panelMap.size > 0) return;
    var items = menuBar.querySelectorAll('.gth-list-menu-item');
    items.forEach(function (li) {
      var panel = li.querySelector(':scope > .gth-menu-megamenu');
      if (!panel) return;
      panel.classList.add('gth-megamenu-portal');
      menuBar.appendChild(panel); /* move to .wbmenuup, outside the nav */
      panelMap.set(li, panel);
    });
  }

  /* ── Restore panels to their original li on desktop ──────────────────── */
  function restorePanels() {
    panelMap.forEach(function (panel, li) {
      panel.classList.remove('gth-megamenu-portal', 'is-open');
      li.appendChild(panel);
    });
    panelMap.clear();
  }

  /* ── Active-item scroll-into-view ─────────────────────────────────────── */
  function scrollActiveIntoView() {
    var nav = document.querySelector('.wbmenuup .gth-menu-nav');
    if (!nav) return;
    var active = nav.querySelector('.gth-list-menu-item.active');
    if (active) {
      /* use scrollLeft instead of scrollIntoView() to avoid scrolling the page */
      nav.scrollLeft = active.offsetLeft - (nav.clientWidth - active.offsetWidth) / 2;
    }
  }

  /* ── Close any open panel ─────────────────────────────────────────────── */
  function closeOpen() {
    panelMap.forEach(function (panel, li) {
      if (panel.classList.contains('is-open')) {
        panel.classList.remove('is-open');
        var link = li.querySelector(':scope > a');
        if (link) link.removeAttribute('aria-expanded');
      }
    });
  }

  /* ── Tap-toggle logic ─────────────────────────────────────────────────── */
  function onNavClick(e) {
    if (!mq.matches) return;

    var link = e.target.closest('.gth-list-menu-item > a');
    if (!link) return;

    var li = link.parentElement;
    if (li.classList.contains('disabled')) return;

    var panel = panelMap.get(li);
    if (!panel || !panel.querySelector('a')) return; /* no children — let navigate */

    if (panel.classList.contains('is-open')) {
      /* second tap on already-open item → navigate */
      return;
    }

    e.preventDefault();
    closeOpen();
    panel.classList.add('is-open');
    link.setAttribute('aria-expanded', 'true');
  }

  /* ── Outside-tap closes panel ─────────────────────────────────────────── */
  function onDocClick(e) {
    if (!mq.matches) return;
    if (!e.target.closest('.wbmenuup')) closeOpen();
  }

  /* ── Escape key closes panel ──────────────────────────────────────────── */
  function onKeydown(e) {
    if (e.key === 'Escape') closeOpen();
  }

  /* ── Breakpoint crossing ──────────────────────────────────────────────── */
  mq.addEventListener('change', function () {
    closeOpen();
    if (mq.matches) {
      portalPanels();
      scrollActiveIntoView();
    } else {
      restorePanels();
    }
  });

  function init() {
    var nav = document.querySelector('.wbmenuup .gth-menu-nav');
    if (!nav) return;

    nav.addEventListener('click', onNavClick);
    document.addEventListener('click', onDocClick);
    document.addEventListener('keydown', onKeydown);

    if (mq.matches) {
      portalPanels();
      scrollActiveIntoView();
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
